export default __webpack_public_path__ + "static/media/add_business.fbb1c8b3.svg";